/** The four launch verticals (Garnet PRD §1.4, §38): config + dataset, never a fork. */
export const MEDICAL = {
    vertical: 'medical',
    display_name: 'Medical equipment',
    identity: {
        identifier_label: 'UDI-DI',
        identifier_kinds: ['basic_udi_di', 'udi_di', 'gtin'],
        carrier: 'gs1_datamatrix',
        parse_hint: 'Scan or paste the full UDI carrier string; DI and PI parse live.',
    },
    upload: {
        document_labels: ['CE certificate (MDR)', 'ISO 13485 certificate', 'Declaration of conformity', 'Free-sale certificate'],
        baseline_documents: ['business_registration', 'ce_mdr_cert', 'declaration_of_conformity', 'insurance_certificate'],
    },
    decision_wording: {
        qualify: 'Qualify supplier',
        qualify_with_conditions: 'Qualify with conditions',
        block: 'Block supplier',
    },
    portal_copy: {
        invitation_heading: 'You have been asked to verify a medical-device supply relationship',
        submit_heading: 'Submit your device and certificate details',
    },
    connector_set: ['eudamed_dataset', 'nando', 'openfda', 'accessgudid', 'mhra_dors', 'mhra_fsn', 'cdsco_sugam', 'ede', 'gs1_gepir', 'companies_house'],
    classification: { core_domain: 'medical', rule_set_hint: 'EU-MDR-AnnexVIII' },
    design_examples: {
        asset_example: 'Infusion pump, Class IIb',
        regulation_examples: ['Regulation (EU) 2017/745', 'MDR Annex VIII Rule 12'],
    },
};
export const AUTOMOTIVE = {
    vertical: 'automotive',
    display_name: 'Automotive safety-critical parts',
    identity: {
        identifier_label: 'Part number / e-mark',
        identifier_kinds: ['part_number', 'vin', 'reg_number'],
        carrier: 'gs1_128',
        parse_hint: 'Enter the part number; add a VIN for vehicle-context checks.',
    },
    upload: {
        document_labels: ['Type-approval certificate', 'E-mark approval', 'Test report', 'Conformity of production'],
        baseline_documents: ['business_registration', 'e_mark_approval', 'declaration_of_conformity', 'insurance_certificate'],
    },
    decision_wording: {
        qualify: 'Qualify supplier',
        qualify_with_conditions: 'Qualify with conditions',
        block: 'Block supplier',
    },
    portal_copy: {
        invitation_heading: 'You have been asked to verify an automotive parts supply relationship',
        submit_heading: 'Submit your part and type-approval details',
    },
    connector_set: ['nhtsa_vpic', 'nhtsa_recalls', 'unece_emark', 'ameca', 'eu_safety_gate', 'arai_ais', 'wco_ipm', 'gs1_gepir', 'companies_house'],
    classification: { core_domain: 'automotive', rule_set_hint: 'UNECE-category' },
    design_examples: {
        asset_example: 'Brake disc, safety-critical',
        regulation_examples: ['UNECE R13H', 'UNECE R90'],
    },
};
export const ELECTRONICS = {
    vertical: 'electronics',
    display_name: 'Electronics and semiconductors',
    identity: {
        identifier_label: 'GTIN / part number',
        identifier_kinds: ['gtin', 'part_number'],
        carrier: 'gs1_datamatrix',
        parse_hint: 'Enter the GTIN; the check digit validates locally before any lookup.',
    },
    upload: {
        document_labels: ['FCC grant', 'UL certificate', 'Test report', 'Declaration of conformity'],
        baseline_documents: ['business_registration', 'fcc_grant', 'declaration_of_conformity', 'insurance_certificate'],
    },
    decision_wording: {
        qualify: 'Qualify supplier',
        qualify_with_conditions: 'Qualify with conditions',
        block: 'Block supplier',
    },
    portal_copy: {
        invitation_heading: 'You have been asked to verify an electronics supply relationship',
        submit_heading: 'Submit your component and certification details',
    },
    connector_set: ['fcc_id', 'ul_product_iq', 'erai', 'gidep', 'eu_safety_gate', 'cpsc', 'gs1_gepir', 'wco_ipm', 'companies_house'],
    classification: { core_domain: 'electronics', rule_set_hint: 'compliance-applicability' },
    design_examples: {
        asset_example: 'Microcontroller lot, AS6171 test path',
        regulation_examples: ['FCC Part 15', 'AS6171'],
    },
};
export const AERONAUTICS = {
    vertical: 'aeronautics',
    display_name: 'Aeronautics and aerospace parts',
    identity: {
        identifier_label: 'Part / serial number',
        identifier_kinds: ['part_number'],
        carrier: 'none',
        parse_hint: 'Enter the part number and serial; back-to-birth traceability applies.',
    },
    upload: {
        document_labels: ['EASA Form 1', 'FAA 8130-3', 'AS9100 certificate', 'Back-to-birth trace file'],
        baseline_documents: ['business_registration', 'declaration_of_conformity', 'insurance_certificate'],
    },
    decision_wording: {
        qualify: 'Qualify supplier',
        qualify_with_conditions: 'Qualify with conditions',
        block: 'Block supplier',
    },
    portal_copy: {
        invitation_heading: 'You have been asked to verify an aerospace parts supply relationship',
        submit_heading: 'Submit your part, release tag, and approval details',
    },
    connector_set: ['easa', 'faa_registry', 'caa_dgca_gcaa', 'iaqg_oasis', 'ata_spec2000', 'gs1_gepir', 'companies_house'],
    classification: { core_domain: 'aeronautics', rule_set_hint: 'EASA-Part21-applicability' },
    design_examples: {
        asset_example: 'Turbine blade, PMA part',
        regulation_examples: ['EASA Part 21', 'FAA 8130-3'],
    },
};
export const LAUNCH_VERTICALS = [MEDICAL, AUTOMOTIVE, ELECTRONICS, AERONAUTICS];
//# sourceMappingURL=verticals.js.map